import styled, { css } from 'styled-components';
import ThemeHelper from '../../themes/theme-helper';
import {
  flexbox, flexDirection, alignItems, justifyContent
} from '../../styles/helpers/flexbox';

const SearchContainer = styled.div`
    ${flexbox()}

    .clear {
      padding: 0 0 0 10px;
      align-self: flex-end;
    }
`;

const SearchableListWrapper = styled.div((props) => {
  const { colours, typography } = ThemeHelper.getTheme(props);

  return `   
        ${flexbox()}
        border: 1px solid ${colours.grey[400]};
        border-radius: 5px;
        height: 34px;
        font-family: ${typography.family};
        font-size: 15px;
        outline: none;
        
        .searchText {
          width: 92%;
          margin: auto 4px;
          ${flexbox()}
          ${alignItems('center')}
        }
        
        .searchLogo {
               width: 8%;
               height: 36px;
               display: flex;
               justify-content: center;
               align-items: center;
               cursor: pointer;
               
               [class*="svgIconComponent"] {
                   width: 18px;
               }
        }
      `;
});

const InputWrapper = styled.input((props) => {
  const { typography } = ThemeHelper.getTheme(props);

  return ` 
        height: 25px;
        border: none;
        font-family: ${typography.family};
        font-size: 15px;
        outline: none;
        padding-left: 4px;
        width: 97%;

        &::-webkit-input-placeholder {
            color: lightgray;
            font-weight: 600;
        }

        &:-ms-input-placeholder {
            color: lightgray;
            font-weight: 600;
        }
    `;
});

const SelectPanelWrapper = styled.div((props) => {
  const { colours, typography } = ThemeHelper.getTheme(props);
  const { height } = props;
  const footerHeight = 60;

  return css`  
    ${flexbox()}
    ${flexDirection('column')}
    z-index: 10;
    background-color: white;
    height: 400px;
    border: 1px solid ${colours.grey[200]};
    border-top: none;
    flex-grow: 1;
    
    .panelFooter {
       ${flexbox()}
       ${alignItems('center')}
       ${justifyContent('space-between')}
       
       height: 60px;
       background: #cfd2d4;
       width: 100%;
       
       .uncheck {
         margin-left: 10px;
       }
       
       .apply {
         margin-right: 10px;
       }
    }

    .panelBody {
       height: ${height ? `${height - footerHeight}px` : '340px'};
       overflow-y: scroll;
       
       .strand {
         padding: 10px;
         
         .wrapper {
           ${flexbox()}
           
           .Description {
             width: 96%;
             ${flexbox()}
             ${alignItems('center')}
           }
           
           .icon {
              cursor: pointer;
           }
         }
         
         svg {
          path {
            fill: ${colours.grey[700]} !important;
          }
         }
         
         [class*="svgIconComponent"] {
                   width: 16px;
                   @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
                    height: 23px;
                  }
         }
       }
       
        .line {
           width: 95%;
           border-top: 2px solid ${colours.grey[400]};
         }
       
       .spacer {
        padding-left: 15px;
       }
    }
    
     .unCheckAllButton {
      width: max-content;
      height: 30px;
      font-family: ${typography.family};
      font-size: 14px;
      font-weight: 600;
     }

     .previewButton {
       height: 25px;
       border-radius: 5px;
       background-color: #57caff;
       border: 0;
       color: #000;
       padding-left: 8px;
       padding-right: 8px;

       .isvg {
          height: 15px;
          width: 15px;
        }
     }
     
     .applyButton {
      width: max-content;
      height: 30px;
     }
  `;
});

const showElement = bool => ({
  display: bool ? '' : 'none'
});

const FilterWrapper = styled.div`
  ${flexDirection('column')}
  flex-grow: 1;
  font-size: 14px;
`;

const FilteredListWrapper = styled.span((props) => {
  const { colours } = ThemeHelper.getTheme(props);
  return `
    path {
      fill: ${colours.grey[600]} !important;
    }
  `;
});

export {
  SearchableListWrapper,
  InputWrapper,
  SelectPanelWrapper,
  showElement,
  SearchContainer,
  FilterWrapper,
  FilteredListWrapper };
